/**
 * Сервис для получения размера возможной предоплаты (10%, 50%).
 * @param tourData - набор данных необходимых для получения предоплаты.
 * Правило следующее: самым приоритетным для показа являтся более низкая предоплата.
 * @returns {Object} - возможная первоначальная оплата (10%, 50%) с условиями.
 */
export default (tourData) => {
    const {
        firstPaymentDefinitions: firstPaymentDefinitionsDrilldown,
        tourProduct,
    } = tourData;

    const tour = tourProduct?.tour || {};
    const tourFirstPaymentDefinitions = tour.firstPaymentDefinitions || [];

    return _.reduce(firstPaymentDefinitionsDrilldown, (currentFirstPayment, drilldown) => {
        const { id, firstPaymentPart } = drilldown;

        if (~tourFirstPaymentDefinitions.indexOf(id)) {
            const isAbsentFirstPayment = !currentFirstPayment.firstPaymentPart;
            const isCurrentFirstPaymentLess = firstPaymentPart <= currentFirstPayment.firstPaymentPart;

            if (isAbsentFirstPayment || isCurrentFirstPaymentLess) {
                return drilldown;
            }
        }

        return currentFirstPayment;
    }, {});
};
